import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FaqAccordion, FAQ_LABELS } from "../components/FaqAccordion";
import { useFaq } from "../components/FaqWidget";

const TOPICS = ["all", "cellar", "club", "gift"];

export default function FaqPage() {
  const [params, setParams] = useSearchParams();
  const topic = TOPICS.includes(params.get("topic") || "") ? (params.get("topic") as string) : "all";
  const { data, isLoading } = useFaq();
  const items = (data?.items || []).filter((it) => topic === "all" || it.audiences.includes(topic));
  return (
    <div className="max-w-4xl" data-testid="content-page-faq">
      <div className="eyebrow">Good to know</div>
      <h1 className="mt-3 font-serif text-4xl font-medium tracking-tight sm:text-5xl" data-testid="content-title">Your questions answered</h1>
      <p className="mt-4 max-w-2xl text-sm leading-relaxed text-neutral-600">Everything about the Cellar Plan, the Wine Club and gifting a subscription. Tap a question to open it.</p>
      <div className="mt-8 flex flex-wrap gap-2" data-testid="faq-topics">
        {TOPICS.map((t) => (
          <button key={t} type="button" onClick={() => setParams(t === "all" ? {} : { topic: t })} aria-pressed={topic === t} className={`border px-4 py-2 font-brand text-[12px] font-bold uppercase tracking-[0.12em] transition-colors duration-200 ${topic === t ? "border-[var(--wine)] bg-[var(--wine)] text-[var(--paper)]" : "border-border hover:border-[var(--wine)] hover:text-[var(--wine)]"}`} data-testid={`faq-topic-${t}`}>{t === "all" ? "Everything" : FAQ_LABELS[t]}</button>
        ))}
      </div>
      <div className="mt-8">{isLoading ? <p className="text-sm text-neutral-500">Loading…</p> : <FaqAccordion items={items} />}</div>
      <div className="mt-12 flex flex-wrap gap-6 border-t border-border pt-6 text-xs text-neutral-500">
        <Link to="/terms" className="underline underline-offset-4" data-testid="content-switch">Terms & Conditions →</Link>
        <Link to="/contact" className="underline underline-offset-4">Still have a question? Contact us →</Link>
      </div>
    </div>
  );
}
